import React from "react";
import {Col} from 'reactstrap'
import {useParams} from "react-router-dom";
import OpeningHours from "../../../components/openinghours/OpeningHours";
import {useDispatch} from 'react-redux';
import * as api from "../../../core/api";
import {toastSuccess} from "../../../core/utils/appUtil";
import handleError from "../../../core/utils/errorUtil";
import PartnerPage from "./PartnerPage";
import {openPartnerOpeningHoursPage} from "../../../actions/partners";
import {createAction} from "../../../core/utils/appUtil";
import {OPENING_HOUR_FORM_SAVED} from "../../../reducers/openingHourForm";

let PartnerAvailabilityPage = () => {

    let params = useParams();

    let partnerId = params.id

    let dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(openPartnerOpeningHoursPage(partnerId))
    }, [partnerId, dispatch])

    let apiCall = (data) => {
        let request = api.updatePartnerOpeningHours(data, partnerId, []);
        return request.then(() => {
            dispatch(createAction(OPENING_HOUR_FORM_SAVED))
            toastSuccess('Zapisano!')
        }).catch(error => handleError(error, dispatch))
    }

    let [loading, setLoading] = React.useState(false)

    let submit = async (data) => {
        setLoading(true);
        await apiCall(data);
        setLoading(false);
    }

    let resetForm = () => {
        dispatch(openPartnerOpeningHoursPage(partnerId))
    }

    return <PartnerPage partnerId={partnerId}>
        <Col lg={{size: 6, offset: 3}}>
            <OpeningHours resetForm={resetForm} onSubmit={submit} duringSubmit={loading}/>
        </Col>
    </PartnerPage>
}

export default PartnerAvailabilityPage
